var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalleticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2002 16.8H18.4002",
    stroke: "#FB8500",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0663 17.6001H24.9847C23.5567 17.6001 22.3999 18.6745 22.3999 20.0001C22.3999 21.3257 23.5575 22.4001 24.9839 22.4001H27.0663C27.1335 22.4001 27.1663 22.4001 27.1943 22.3985C27.6263 22.3721 27.9703 22.0529 27.9983 21.6521C27.9999 21.6265 27.9999 21.5953 27.9999 21.5337V18.4665C27.9999 18.4049 27.9999 18.3737 27.9983 18.3481C27.9695 17.9473 27.6263 17.6281 27.1943 17.6017C27.1671 17.6001 27.1335 17.6001 27.0663 17.6001Z",
    stroke: "#FB8500",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.172 17.6001C27.1096 16.1025 26.9096 15.1841 26.2624 14.5377C25.3256 13.6001 23.8168 13.6001 20.8 13.6001H18.4C15.3832 13.6001 13.8744 13.6001 12.9376 14.5377C12 15.4745 12 16.9833 12 20.0001C12 23.0169 12 24.5257 12.9376 25.4625C13.8744 26.4001 15.3832 26.4001 18.4 26.4001H20.8C23.8168 26.4001 25.3256 26.4001 26.2624 25.4625C26.9096 24.8161 27.1104 23.8977 27.172 22.4001",
    stroke: "#FB8500",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.793 20H24.801",
    stroke: "#FB8500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalleticon);
export default __webpack_public_path__ + "static/media/walleticon.b16a33b4bea8f5dfb964d193593893ca.svg";
export { ForwardRef as ReactComponent };